package core.validation.field

import core.validation.validator.Validator

class StringField(
    private vararg val validators: Validator<String>,
) : FieldImpl<String>(
        initialValue = "",
        validators = validators,
    )
